import axios from 'axios'
import moment from 'moment-timezone'
import { STOCKS_ENDPOINT } from 'cfgCommon/endpoints'

const MULTIPLE_STOCK_AUDIT_ERROR_CODE = 206
const MULTIPLE_STOCK_EXCEL_ERROR_CODE = 206

export async function confirmStockImportation(body) {
  const timezoneUser = moment.tz.guess()
  body.timezoneUser = timezoneUser

  // TODO: Agregar summary y stocks cuando el backend este listo para descargar el excel
  const response = await axios.post(
    `${STOCKS_ENDPOINT}/createMultipleStock`,
    body,
    { responseType: 'blob',
      timeout: 1800000 // 30 minutos
    }
  )
  if (
    response.status === MULTIPLE_STOCK_AUDIT_ERROR_CODE ||
    response.status === MULTIPLE_STOCK_EXCEL_ERROR_CODE
  ) {
    return null
  } else {
    return response.data
  }
}
